import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/Core/services/session.service';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent {
  constructor(private router: Router, public session: SessionService) {}

  // goHome() {
  //   sessionStorage.removeItem('productId');
  //   sessionStorage.removeItem('AppId');
  //   sessionStorage.removeItem('selectedMerchant');
  //   sessionStorage.removeItem('selectedMerchantBranch');
  //   if (sessionStorage.getItem('mobile')) {
  //     (window as any).changeTextsss();
  //   } else this.router.navigate(['landing']);
  // }
}
